/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import { Redirect, Route } from "react-router-dom";
import { AuthConsumer } from "./AuthContext";
import RenderFullPageLoading from "./assets/component/RenderFullPageLoading.js";

function run(Component, rest) {
  function renderComponent(t, props, logout, language) {
    const currentPath = props.location.pathname.substring(1).toUpperCase();
    //set language Data
    const languageObj = t(currentPath, { returnObjects: true });

    return (
      <Component
        {...props}
        logout={logout}
        language={language}
        languageObj={languageObj}
        RenderFullPageLoading={RenderFullPageLoading}
      />
    );
  }

  return (
    <AuthConsumer>
      {({ t, isAdminAuth, logout, language }) => (
        <Route
          render={(props) =>
            isAdminAuth ? (
              renderComponent(t, props, logout, language)
            ) : (
              <Redirect to="/AdminLogin" />
            )
          }
          {...rest}
        />
      )}
    </AuthConsumer>
  );
}

const AdminProtectedRoute = ({ component: Component, ...rest }) =>
  run(Component, rest);

export default AdminProtectedRoute;
